import { Outlet } from 'react-router-dom';
import { useState } from 'react';

import Sidebar from './Sidebar';
import Header from './Header';

export default function DefaultLayout(){
    const [mobileOpen, setMobileOpen] = useState(false);


    return(
        <>
        <div className='flex h-screen bg-gray-50 dark:bg-gray-900 antialiased text-gray-700 dark:text-gray-200 text-base'>
            <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />

            {mobileOpen && (
                <div
                className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
                onClick={() => setMobileOpen(false)}
                />
            )}


            <div className='flex flex-col flex-1 w-full overflow-y-auto'>
                <Header toggleSidebar={() => setMobileOpen(!mobileOpen)} />
                 <main className="flex-1 overflow-y-auto px-5 py-6 bg-gray-50 dark:bg-gray-900">
                    <Outlet />
                </main>
            </div>
        </div>
        
        
        </>
    )
}